export default "__VITE_ASSET__BL$ZYX42__"